import { styled } from '@linaria/react'
import { useTranslation } from 'react-i18next'
import 'blaze-slider/dist/blaze.css'
import useBlazeSlider from '../../hooks/useBlazeSlider'
import useDimensions from '../../hooks/useDimensions'
import { useState } from 'react'
import { useNavigate } from '@tanstack/router'
import { useModal } from '@ebay/nice-modal-react'
import LoginModal from '../common/log-in-modal'
import { useBoundStore } from '../../store/store'
import plus_15 from '../../assets/home-v3/plus_15.webp'
import star from '../../assets/home-v3/star.webp'
import trophy from '../../assets/home-v3/trophy.webp'
import headphones from '../../assets/home-v3/headphones.webp'
import fast_money from '../../assets/home-v3/fast_money.webp'
import { CASINO_CATEGORIES } from '../../constants/casino'

const Container = styled.div`
  background-color: #009fda;
  padding: 36px 24px;
  @media (min-width: 1200px) {
    padding: 80px 24px;
  }
`

const Btn = styled.button`
  padding: 12px 0;
  background-color: var(--primary-btn-bg);
  border-radius: 6px;
  width: 100%;
  text-align: center;
  border-radius: 6px;
  margin: 0 auto 12px;
  display: block;
  p {
    font-size: 16px;
    color: var(--primary-btn-txt);
    text-transform: uppercase;
  }
  &.login {
    background-color: var(--highlight);
  }
`

const BtnContainer = styled.div`
  gap: 12px;
  margin-top: 36px;
  display: flex;
  justify-content: center;
  grid-template-columns: 1fr 1fr;
  width: 100%;
`

const Title = styled.h3`
  font-family: 'Poppins';
  font-size: 36px;
  font-weight: 900;
  margin-bottom: 16px;
  text-align: center;
  color: #fff;
  @media (min-width: 1200px) {
    margin-bottom: 44px;
    font-size: 48px;
  }
`

const Card = styled.div`
  text-align: center;
  cursor: pointer;
  img {
    width: 100px;
    height: 100px;
    margin-bottom: 12px;
    opacity: 0.7;
    transition: 0.3s ease-in-out;
  }
  .title {
    font-family: 'Poppins';
    font-weight: 800;
    text-transform: uppercase;
    font-style: italic;
    font-size: 30px;
    line-height: 110%;
    color: #fff;
    opacity: 0.7;
    margin-bottom: 8px;
    transition: 0.3s ease-in-out;
  }
  .subtitle {
    font-family: 'Poppins';
    font-size: 20px;
    color: #fff;
    opacity: 0.7;
    margin-bottom: 12px;
    transition: 0.3s ease-in-out;
  }
  .label {
    font-family: 'Poppins';
    font-size: 16px;
    color: #fff;
  }
  &.active {
    .title,
    .subtitle,
    img {
      opacity: 1;
    }
  }
  @media (min-width: 1200px) {
    width: 100%;
    .img {
      margin-bottom: 20px;
    }
    .title {
      font-size: 30px;
    }
  }
`

const DotContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 12px;
  margin-top: 24px;
`

const Dot = styled.div<{ isActive: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  transition: all 0.2s linear;
  cursor: pointer;
  background-color: #fff;
  opacity: ${({ isActive }) => (isActive ? '1' : '0.5')};
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: flex-start;
  width: 1400px;
  margin: 0 auto;
`

const Border = styled.div`
  width: 100%;
  height: 4px;
  background-color: #fff;
  position: relative;
  width: 1400px;
  margin: 36px auto 0;
`

const Arrow = styled.svg`
  position: absolute;
  bottom: -3px;
  left: 0;
  transition: 0.3s ease-in-out;
`

const Label = styled.p`
  font-family: 'Poppins';
  font-size: 20px;
  margin-top: 36px;
  color: #fff;
  text-align: center;
  font-weight: 300;
`

const WhyUs = () => {
  const navigate = useNavigate()
  const login = useModal(LoginModal)
  const { isDesktop } = useDimensions()
  const { t } = useTranslation(['common', 'homeV2'])
  const username = useBoundStore(state => state.user.username)
  const { elRef, slideTo, activeKey } = useBlazeSlider({
    all: {
      loop: true,
      enableAutoplay: true,
    },
  })
  const [activeCard, setActiveCard] = useState(2)

  const CARDS = [
    {
      title: '15+ Años de Experiencia',
      subtitle: 'Lideres en Latino America',
      label:
        'FUN88 comprende tu pasión por el deporte y celebra la experiencia de ser un ganador contigo.',
      icon: plus_15,
    },
    {
      title: 'Programa de Lealtad',
      subtitle: 'Cashback y muchos otros beneficios',
      label:
        'FUN88 comprende tu pasión por el deporte y celebra la experiencia de ser un ganador contigo.',
      icon: star,
    },
    {
      title: 'Nuestros Ganadores',
      subtitle: 'Celebramos con ellos',
      label:
        'FUN88 comprende tu pasión por el deporte y celebra la experiencia de ser un ganador contigo.',
      icon: trophy,
    },
    {
      title: 'Atención al cliente',
      subtitle: '24/7',
      label:
        'FUN88 comprende tu pasión por el deporte y celebra la experiencia de ser un ganador contigo.',
      icon: headphones,
    },
    {
      title: 'Fácil, rápido y seguro',
      subtitle: 'Tus pagos en 20 Minutos',
      label:
        'FUN88 comprende tu pasión por el deporte y celebra la experiencia de ser un ganador contigo.',
      icon: fast_money,
    },
  ] as const

  if (isDesktop) {
    return (
      <Container>
        <Title>{t('why-fun88', { ns: 'homeV2' })}</Title>
        <Grid>
          {CARDS.map((card, index) => (
            <Card
              key={index}
              className={`${activeCard === index ? 'active' : ''} v-flx-ctr`}
              onClick={() => setActiveCard(index)}>
              <img src={card.icon} alt={card.title} />
              <p className="title">{card.title}</p>
              <p className="subtitle">{card.subtitle}</p>
            </Card>
          ))}
        </Grid>
        <Border>
          <Arrow
            width="280"
            height="13"
            viewBox="0 0 280 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ left: `${activeCard * 280}px` }}>
            <rect y="6" width="280" height="4" fill="#59FF3D" />
            <path d="M136.5 0L145.593 9.75H127.407L136.5 0Z" fill="#59FF3D" />
          </Arrow>
        </Border>
        <Label>
          {CARDS[activeCard].title} {CARDS[activeCard].label}
        </Label>
      </Container>
    )
  }

  return (
    <Container>
      <Title>{t('why-fun88', { ns: 'homeV2' })}</Title>
      <div className="blaze-slider" ref={elRef}>
        <div className="blaze-container">
          <div className="blaze-track-container">
            <div className="blaze-track">
              {CARDS.map((card, index) => (
                <Card key={index} className={`card-${index} active v-flx-ctr`}>
                  <img src={card.icon} alt={card.title} />
                  <p className="title">{card.title}</p>
                  <p className="subtitle">{card.subtitle}</p>
                  <p className="label">{card.label}</p>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
      <DotContainer>
        {CARDS.map((_card, index) => (
          <Dot
            key={index}
            isActive={index === activeKey}
            onClick={() => slideTo(index)}
          />
        ))}
      </DotContainer>
      <BtnContainer>
        {username ? (
          <Btn
            onClick={() =>
              navigate({
                to: '/casino/$category',
                params: { category: CASINO_CATEGORIES[0].label },
              })
            }>
            <p>JUGAR AHORA</p>
          </Btn>
        ) : (
          <>
            <Btn onClick={() => navigate({ to: '/register' })}>
              <p>{t('register')}</p>
            </Btn>
            <Btn className="login" onClick={() => login.show()}>
              <p>{t('login')}</p>
            </Btn>
          </>
        )}
      </BtnContainer>
    </Container>
  )
}

export default WhyUs
